<div
  class="d-flex flex-column align-items-center h-100 w-100 px-4 py-4 modal-main"
>
  <div class="header w-100">
    <div class="d-flex justify-content-between">
      <div>
        <img
          src="/assets/svg/ico-chevron-back-outline.svg"
          class="pointer-cursor mt-2"
          (click)="navigateBack()"
        />
      </div>

      <h1 class="modal-title m-auto pl-2 col-9 text-center">
        <app-with-tooltip [showHelpCursor]="true">
          {{ existingName }}
        </app-with-tooltip>
        {{ 'SETTINGS' | translate }}
      </h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor mb-4"
        (click)="closeDialog()"
      />
    </div>
  </div>

  <div class="mb-3">
    <p class="text-center heading-one pt-2">{{ 'NAME_YOUR_LOCK' | translate }}</p>
    <p class="paragraph-text text-center mx-4">
      {{ 'PERSONALIZE_YOUR_LOCK_EXPERIENCE' | translate }}
    </p>
  </div>

  <div
    class="d-flex flex-column justify-content-start w-100 px-3 form-container"
  >
    <form [formGroup]="formGroup">
      <div class="rounded-top form-field">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ 'NAME_ASTERIK' | translate }}</mat-label>
          <input matInput formControlName="deviceName" />
          <mat-error>
            <span *ngIf="formInstance?.deviceName?.errors?.required">{{
              'YOU_MUST_ENTER_DEVICE_NAME' | translate
            }}</span>
          </mat-error>

          <mat-error *ngIf="formInstance?.deviceName?.errors?.maxlength"
            >{{ 'MAXIMUM_OF_CHARACTER' | translate }}
          </mat-error>
          <mat-error *ngIf="formInstance?.deviceName?.errors?.whitespace"
            >{{ 'EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED' | translate }}
          </mat-error>

          <mat-error>
            <span
              *ngIf="
                formInstance?.deviceName?.errors?.requiredSpecialCharForUnitName
              "
              >{{ 'YOU_MUST_ENTER_VALID_DEVICE_NAME' | translate }}</span
            >
            <span
              *ngIf="
                formInstance?.deviceName?.errors
                  ?.firstCharacterIsSpecialCharacter
              "
              >{{
                'LOCK_NAME_SHOULD_NOT_START_WITH_SPECIAL_CHARACTER' | translate
              }}</span
            >
          </mat-error>
        </mat-form-field>
      </div>

      <div class="text-center mt-30 mb-50">
        <div>
          <img src="assets/svg/ico-lock-circle-outline-white.svg" />
        </div>
        <div>
          <h3 class="sub-heading m-auto">{{ 'NAMING_YOUR_LOCK' | translate }}</h3>
        </div>

        <div>
          <p class="desc m-auto">
            <strong>{{ 'WHEN_NAMING_YOR_LOCK_NAME' | translate }}</strong>
          </p>
        </div>
        <div>
          <p class="desc m-auto">
            <strong>{{ 'EXAMPLE_LOCK_NAME' | translate }}</strong>
          </p>
        </div>
      </div>
      <div class="row w-100 py-3">
        <div class="w-100">
          <button
            class="btn btn-danger update-btn px-3"
            [disabled]="!formGroup.valid"
            (click)="onUpdateName()"
          >
            {{ 'UPDATE' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
